import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/stock-transfers')({
  staticData: { crumb: 'stockTransfers' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.read'),
  component: Outlet,
})
